import * as React from "react";

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110" {...props}>
      <path fill="none" d="M0 0h150v110H0z" />
      <path
        d="M100.8 66.6c-.6-4.2-3-8-6.5-10.4 1.3-1.8 2.1-4 2.1-6.4 0-6-4.9-10.8-10.8-10.8-6 0-10.8 4.9-10.8 10.8 0 2.4.8 4.6 2.1 6.4-1.8 1.3-3.4 3-4.5 4.9l.2.2c-.3-.3-.6-.5-1-.8 1.3-1.8 2.1-4 2.1-6.4 0-6-4.9-10.8-10.8-10.8S52 48.1 52 54.1c0 2.4.8 4.6 2.1 6.4-3.5 2.4-5.9 6.2-6.5 10.4-.1.9.1 1.7.6 2.4s1.3 1.1 2.1 1.3h24.4c1.8 0 3.2-1.5 3.2-3.2v-.5c0-.2-.1-.4-.1-.6h19.6c1.8 0 3.2-1.5 3.2-3.2.2-.2.2-.3.2-.5zM85.6 41.9c4.3 0 7.8 3.5 7.8 7.8s-3.5 7.8-7.8 7.8-7.8-3.5-7.8-7.8 3.5-7.8 7.8-7.8zm-12 20.2s-.1 0 0 0c-.1 0 0 0 0 0zM62.9 46.2c4.3 0 7.8 3.5 7.8 7.8s-3.5 7.8-7.8 7.8-7.9-3.4-7.9-7.7 3.6-7.9 7.9-7.9zm12 25.4h-24c-.1 0-.1-.1-.2-.1 0 0-.1-.1 0-.2.5-3.6 2.6-6.7 5.6-8.7 1.8 1.4 4.1 2.2 6.6 2.2s4.7-.8 6.6-2.2c3 1.9 5.1 5.1 5.7 8.7-.1.2-.2.3-.3.3zm22.7-4.3H77.1c-.6-1.5-1.4-2.8-2.5-4.1 1-2 2.5-3.7 4.4-4.9 1.8 1.4 4.1 2.2 6.6 2.2s4.7-.8 6.6-2.2c3 1.9 5.1 5.1 5.7 8.7-.1.2-.2.3-.3.3z"
        fill="#424242"
      />
    </svg>
  );
}

export default Icon;
